var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "on-clickaway",
          rawName: "v-on-clickaway",
          value: _vm.closeSearch,
          expression: "closeSearch"
        }
      ],
      staticClass: "c-search",
      class: { "c-search--mini": _vm.mini }
    },
    [
      _vm.mini
        ? _c(
            "div",
            {
              staticClass: "c-search__button",
              on: {
                click: function($event) {
                  return _vm.showInput()
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.translations["Search"]) +
                  "\n\n        "
              ),
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d:
                        "M5.8077 12.0398C2.57829 12.0398 -1.17472e-07 9.35235 -2.60159e-07 6.08805C-4.02874e-07 2.82311 2.57821 0.135583 5.8077 0.135583C9.03799 0.135583 11.6154 2.82319 11.6154 6.08805C11.6154 9.35227 9.03791 12.0398 5.8077 12.0398ZM1.6916 6.08805C1.69161 8.46388 3.55767 10.3482 5.8077 10.3482C8.05838 10.3482 9.92379 8.46396 9.92379 6.08805C9.92379 3.71133 8.0583 1.82719 5.8077 1.82719C3.55775 1.82719 1.6916 3.71142 1.6916 6.08805Z",
                      fill: "#313131"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d:
                        "M8.94512 10.4554L11.6605 13.2258C11.7488 13.317 11.8548 13.3895 11.9721 13.4391C12.0894 13.4887 12.2155 13.5143 12.3431 13.5144C12.4706 13.5145 12.5968 13.4891 12.7142 13.4397C12.8315 13.3903 12.9376 13.318 13.0261 13.227C13.2071 13.0394 13.308 12.7899 13.3078 12.5304C13.3075 12.2709 13.2062 12.0215 13.0249 11.8342L10.309 9.06442C9.93232 8.68189 9.32058 8.67957 8.94395 9.06326C8.76211 9.24982 8.66097 9.49938 8.66206 9.75876C8.66206 10.0103 8.75563 10.263 8.94512 10.4554V10.4554Z",
                      fill: "#313131"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      (_vm.mini && _vm.show) || !_vm.mini
        ? _c("div", { staticClass: "c-search__inputholder" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchString,
                  expression: "searchString"
                }
              ],
              ref: "searchInput",
              staticClass: "c-search__input",
              class: { "c-search__input--active": _vm.products },
              attrs: { placeholder: _vm.translations["Search products..."] },
              domProps: { value: _vm.searchString },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  return _vm.closeSearch($event)
                },
                focus: function($event) {
                  _vm.showClear = true
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchString = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _vm.isLoading
              ? _c(
                  "svg",
                  {
                    staticClass: "c-search__load-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 72 72"
                    }
                  },
                  [
                    _c("g", { attrs: { "data-name": "Layer 2" } }, [
                      _c("path", {
                        attrs: {
                          d:
                            "M36 57.75a21.75 21.75 0 0 1 0-43.5V0a36 36 0 1 0 36 36H57.76A21.75 21.75 0 0 1 36 57.75z",
                          fill: "#313131",
                          "data-name": "Layer 1"
                        }
                      })
                    ])
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isLoading && _vm.showClear
              ? _c(
                  "svg",
                  {
                    staticClass: "c-search__close-icon",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18"
                    },
                    on: {
                      click: function($event) {
                        return _vm.clearInput()
                      }
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M9,3 C9.55228475,3 10,3.44771525 10,4 L10,8 L14,8 C14.5522847,8 15,8.44771525 15,9 C15,9.55228475 14.5522847,10 14,10 L10,10 L10,14 C10,14.5522847 9.55228475,15 9,15 C8.44771525,15 8,14.5522847 8,14 L8,10 L4,10 C3.44771525,10 3,9.55228475 3,9 C3,8.44771525 3.44771525,8 4,8 L8,8 L8,4 C8,3.44771525 8.44771525,3 9,3 Z",
                        opacity: ".6",
                        transform: "rotate(45 9 9)"
                      }
                    })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.products
          ? _c("div", { staticClass: "c-search__dropdown" }, [
              !_vm.products.length
                ? _c(
                    "div",
                    { staticClass: "c-search__result c-search__result--empty" },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.translations[
                              "Sorry, we did not find any matching products"
                            ]
                          ) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "c-search__results" },
                _vm._l(this.products, function(product) {
                  return _c(
                    "a",
                    {
                      key: product.isLoading,
                      staticClass: "c-search__result",
                      attrs: { href: product.link }
                    },
                    [
                      _c("img", { attrs: { src: product.image } }),
                      _vm._v(" "),
                      _c("div", [
                        _c("div", { staticClass: "name" }, [
                          _vm._v(_vm._s(product.title))
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "price" }, [
                          _vm._v(_vm._s(product.price))
                        ])
                      ])
                    ]
                  )
                }),
                0
              )
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }